import { ViewField } from "@/components/dashboard/setting/profile/ProfileView";
import { AddEmployeeConfig } from "@/utils/constant/formConfig.constant";
import { getNestedValue } from "@/utils/helper/form";
import React, { useEffect } from "react";
import { EmployeeSidebar } from "./EmployeeDetails";
import { SideBarContentHeader } from "@/common/ui/SideBar";
import { Image } from "@/common/ui/Image";
import { useParams } from "react-router-dom";
import { useEmployeeInfo } from "@/services/employee.services";
import { OverviewSectionSkeleton } from "@/common/ui/Loader";
import { useSelector } from "react-redux";
import { pageEventSelector } from "@/store/features/dashboardSlice";

interface OverviewProps {
  tab: EmployeeSidebar;
}

const Overview: React.FC<OverviewProps> = ({ tab }) => {
  const { employeeId } = useParams();
  const pageEvent = useSelector(pageEventSelector);
  const { isLoading, data, refetch } = useEmployeeInfo({ empId: employeeId, view_typ: tab.apiKey });
  const isAccountOwnerRole = (data as any)?.userTyp?.label === "Account Owner";

  useEffect(() => {
    if (pageEvent?.keys.includes(tab?.name) && pageEvent?.type === "refresh") {
      refetch();
    }
  }, [pageEvent]);

  if (isLoading) return <OverviewSectionSkeleton />;
  return (
    <div className="flex flex-col w-full h-full">
      {tab?.name && <SideBarContentHeader heading={tab.name} className="!p-4 rounded-llg rounded-b-none" />}
      <div className="overflow-y-auto h-full">
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
          {AddEmployeeConfig.sections.map((section: any) => {
            return section.widgets.map((widget: any) => {
              if (widget?.hideOnViewMode) return null;
              if (widget.field === "reportingManager" && isAccountOwnerRole) return null;

              const prefillField = widget?.viewField || widget?.apiField || widget.field;
              const fieldValue = prefillField ? getNestedValue(data, prefillField) : undefined;
              return (
                <div className="px-3 py-2 overflow-hidden" key={widget.field}>
                  <ViewField
                    fieldType={widget.widgetType}
                    label={widget.label}
                    viewType={widget?.viewType}
                    value={fieldValue || "-"}
                    field={widget.field}
                    C={widget.field === "address.lineAddress" ? <Image alt=" " src="/icons/direction.svg" /> : ""}
                  />
                </div>
              );
            });
          })}
        </div>
      </div>
    </div>
  );
};

export default Overview;
